import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { WebsiteSettingsRes } from "../../types/ResType";

export const useWebsiteSettings = () => {
  return useQuery<WebsiteSettingsRes, Error>(
    ["get-website-settings"],
    async () => {
      const response = await axiosInstance.get<WebsiteSettingsRes>("config/");

      return response.data;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      retry: 1,
      retryDelay: 2000,
    }
  );
};
